/**
 * Spicy Header — Mega menu hover + mobile nav toggle
 */
(function() {
  'use strict';

  /* ── Mega menu hover logic ── */
  document.querySelectorAll('[data-mega-menu]').forEach(function(item) {
    var timeout;
    var link = item.querySelector('.spicy-header__nav-link');
    var mega = item.querySelector('.spicy-mega');
    if (!link || !mega) return;

    function show() {
      clearTimeout(timeout);
      document.querySelectorAll('[data-mega-menu]').forEach(function(other) {
        if (other !== item) {
          var otherMega = other.querySelector('.spicy-mega');
          var otherLink = other.querySelector('.spicy-header__nav-link');
          if (otherMega) otherMega.setAttribute('aria-hidden', 'true');
          if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
        }
      });
      mega.setAttribute('aria-hidden', 'false');
      link.setAttribute('aria-expanded', 'true');
      // Clamp mega menu to viewport edges
      requestAnimationFrame(function() {
        if (mega.classList.contains('spicy-mega--compact')) {
          var rect = mega.getBoundingClientRect();
          if (rect.left < 8) {
            mega.style.left = '8px';
            mega.style.transform = 'translateY(0)';
          } else if (rect.right > window.innerWidth - 8) {
            mega.style.left = 'auto';
            mega.style.right = '8px';
            mega.style.transform = 'translateY(0)';
          }
        }
      });
    }

    function hide() {
      timeout = setTimeout(function() {
        mega.setAttribute('aria-hidden', 'true');
        link.setAttribute('aria-expanded', 'false');
        // Reset any clamped positioning
        mega.style.left = '';
        mega.style.right = '';
        mega.style.transform = '';
      }, 150);
    }

    item.addEventListener('mouseenter', show);
    item.addEventListener('mouseleave', hide);
    mega.addEventListener('mouseenter', function() { clearTimeout(timeout); });
    mega.addEventListener('mouseleave', hide);

    /* Keyboard support */
    link.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var isOpen = mega.getAttribute('aria-hidden') === 'false';
        if (isOpen) { hide(); } else { show(); }
      }
      if (e.key === 'Escape') { hide(); }
    });
  });

  /* ── Mobile nav drawer ── */
  (function initMobileDrawer() {
    var toggleBtns = document.querySelectorAll('[data-mobile-nav-toggle]');
    var drawer = document.getElementById('MobileNav');
    var backdrop = document.getElementById('MobileNavBackdrop');
    var closeBtn = drawer ? drawer.querySelector('[data-mobile-nav-close]') : null;
    if (!drawer) return;

    var triggerElement = null;

    function syncMobileNavState(isOpen) {
      document.body.classList.toggle('is-mobile-nav-open', isOpen);
      document.documentElement.classList.toggle('is-mobile-nav-open', isOpen);
      window.dispatchEvent(new CustomEvent('spicy:mobile-nav-state', {
        detail: { open: isOpen }
      }));
    }

    function open(triggerEl) {
      triggerElement = triggerEl || document.querySelector('[data-mobile-nav-toggle]');
      drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      syncMobileNavState(true);

      // Set inert on background content
      var main = document.getElementById('MainContent');
      var header = document.querySelector('.spicy-header');
      if (main) main.setAttribute('inert', '');
      if (header) header.setAttribute('inert', '');

      // Update aria-expanded on toggle buttons
      toggleBtns.forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'true');
      });

      // Focus the close button
      if (closeBtn) {
        requestAnimationFrame(function() { closeBtn.focus(); });
      }
    }

    function close() {
      drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
      syncMobileNavState(false);

      // Remove inert
      var main = document.getElementById('MainContent');
      var header = document.querySelector('.spicy-header');
      if (main) main.removeAttribute('inert');
      if (header) header.removeAttribute('inert');

      // Update aria-expanded
      toggleBtns.forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'false');
      });

      // Restore focus to trigger
      if (triggerElement) {
        triggerElement.focus();
        triggerElement = null;
      }
    }

    // Bind toggle buttons
    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var isOpen = drawer.classList.contains('is-open');
        if (isOpen) { close(); } else { open(btn); }
      });
    });

    // Close button
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Backdrop click
    if (backdrop) backdrop.addEventListener('click', close);

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
      }
    });

    // Focus trap
    drawer.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var focusable = drawer.querySelectorAll(
        'a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"]), summary'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // PubSub integration
    if (window.SpicyPubSub) {
      window.SpicyPubSub.subscribe('mobilenav:open', open);
      window.SpicyPubSub.subscribe('mobilenav:close', close);
    }

    syncMobileNavState(drawer.classList.contains('is-open'));
  })();
})();
